/**
 * Early product link intercept (collection/search).
 * Loaded at body start so taps are handled before other scripts.
 * Avoids early-tap refresh, swipe-back and scroll mis-taps on mobile.
 */

(function(){
  var sel = '.template-collection .product-info__name a, .template-collection a.product-card__image-link, .template-collection a[class*=" product-card__image-link"], .template-search .product-info__name a, .template-search a.product-card__image-link, .template-search a[class*=" product-card__image-link"]';
  var MOVE_THRESHOLD = 15;
  var IGNORE_CLICK_MS = 400;
  var lastTouch = null;
  var lastPointer = {};
  var ignoreClickUntil = 0;

  function getLink(el){ return el && el.closest && el.closest(sel) || null; }
  function getTouchEndCoords(e){
    if (e.changedTouches && e.changedTouches[0]) return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
    return { x: e.clientX, y: e.clientY };
  }
  function dist(a,b){ return Math.sqrt((a.x-b.x)*(a.x-b.x)+(a.y-b.y)*(a.y-b.y)); }
  function doNav(link, e){
    if (link.__redirecting) return;
    link.__redirecting = true;
    e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();
    var href = link.href;
    if (!href || href.indexOf('javascript:')===0) return;
    if ((link.getAttribute('target')||'').toLowerCase()==='_blank'){ window.open(href,'_blank','noopener'); return; }
    window.location.assign(href);
  }

  function cancelIfMoved(rec, x, y) {
    if (!rec) return;
    if (dist(rec, { x: x, y: y }) > MOVE_THRESHOLD) return true;
    return false;
  }
  document.addEventListener('touchstart', function(e) {
    var link = e.target && getLink(e.target);
    if (link && e.touches && e.touches[0]) lastTouch = { link: link, x: e.touches[0].clientX, y: e.touches[0].clientY };
    else lastTouch = null;
  }, true);
  document.addEventListener('touchmove', function(e) {
    if (!lastTouch || !e.touches || !e.touches[0]) return;
    if (cancelIfMoved(lastTouch, e.touches[0].clientX, e.touches[0].clientY)) { lastTouch = null; ignoreClickUntil = Date.now() + IGNORE_CLICK_MS; }
  }, { capture: true, passive: true });
  document.addEventListener('pointerdown', function(e) {
    if (e.target.closest(".product-card__wishlist-btn")) {
      // Never clone/replace the card when the tap is on the wishlist button —
      // that DOM churn was interfering with the button's own click state.
    } else if (e.button !== 0 && e.target.closest(".products__col")) {
      e.preventDefault();
      e.stopPropagation();

      let item = e.target.closest(".products__col");
      let wishlist = item.querySelector(".product-card__wishlist-btn"); // keep original wishlist button
      let clone = item.cloneNode(true);

      if (wishlist) {
        let cloneWishlist = clone.querySelector(".product-card__wishlist-btn");
        if (cloneWishlist) {
          cloneWishlist.replaceWith(wishlist); // replace cloned button with original (with its events)
        }
      }

      item.parentNode.replaceChild(clone, item);
    }
    let link = e.target && getLink(e.target);
    if (link) {
      lastPointer[e.pointerId] = { link: link, x: e.clientX, y: e.clientY };
    } else {
      delete lastPointer[e.pointerId];
    }
  }, true);
  document.addEventListener('pointermove', function(e) {
    var rec = lastPointer[e.pointerId];
    if (!rec) return;
    if (cancelIfMoved(rec, e.clientX, e.clientY)) { delete lastPointer[e.pointerId]; ignoreClickUntil = Date.now() + IGNORE_CLICK_MS; }
  }, true);

  function goTouchPointer(e){
    var link = e.target && getLink(e.target);
    if (!link) return;
    var coords = getTouchEndCoords(e);
    var rec = e.pointerId != null ? lastPointer[e.pointerId] : lastTouch;
    if (e.pointerId != null) delete lastPointer[e.pointerId];
    else lastTouch = null;
    if (!rec || rec.link !== link) { ignoreClickUntil = Date.now() + IGNORE_CLICK_MS; return; }
    if (dist(rec, coords) > MOVE_THRESHOLD) { ignoreClickUntil = Date.now() + IGNORE_CLICK_MS; return; }
    doNav(link, e);
  }
  function goClick(e){
    var link = e.target && getLink(e.target);
    if (!link) return;
    if (Date.now() < ignoreClickUntil) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    doNav(link, e);
  }

  document.addEventListener('click', goClick, true);
  document.addEventListener('touchend', goTouchPointer, { capture: true, passive: false });
  document.addEventListener('pointerup', goTouchPointer, { capture: true, passive: false });
  document.addEventListener('touchcancel', function(){ lastTouch = null; }, true);
})();
